jQuery( ".next" ).click(function() {
	
  jQuery('.designer-slider > div').slick('slickNext');
  
});

jQuery( ".prev" ).click(function() {
	
  jQuery('.designer-slider >div').slick('slickPrev');
  
});